import * as React from 'react';

import { ITotalFloorsTag } from '../../../state/tags/definitions/total_floors';
import { TagNew } from '../TagNew';

export interface ITotalFloorsTagItemProps {
  tag: ITotalFloorsTag;
  onDeleteClick(): void;
}

export const TotalFloorsTagItem = (props: ITotalFloorsTagItemProps) => {
  const text = [];

  if (props.tag.min !== undefined) {
    text.push(`от ${props.tag.min}`);
  }

  if (props.tag.max !== undefined) {
    text.push(`до ${props.tag.max}`);
  }

  return <TagNew onDeleteClick={props.onDeleteClick}>Этажей в доме {text.join(' ')}</TagNew>;
};
